import gql from "graphql-tag";

//Logout
export const LOGOUT_MUTATION = gql`
  mutation LogoutUser {
    logoutUser {
      userId
      token
      tokenExpiration
      username
      role
    }
  }
`;
export const AGENCY_COVERAGE_QUERY = gql`
query AccountAgencyCoverages($offset: Int, $limit: Int, $filter: AccountAgencyCoverageFilter) {
  accountAgencyCoverages(offset: $offset, limit: $limit, filter: $filter) {
    account_agency_coverage_id
    account_agency_id {
      agency_name
      abbreviation
    }
    agency_id {
      agency_name
      abbreviation
      state_id {
        state_name
        abbreviation
      }
    }
  }
}`;
export const AGENCIES_QUERY = gql`
query Agencies {
  agencies {
    agency_id
    agency_name
    abbreviation
    site_url
  
  }
}`;
export const ACCOUNT_AGENCY_QUERY = gql`
query AccountAgencies {
  accountAgencies {
    agency_name
    account_agency_id
  }
}`;
export const LOGIN_USER_MUTATION = gql`
  mutation LoginEmployee($username: String!, $password: String!) {
    loginEmployee(username: $username, password: $password) {
      authData {
        token
      }
      employee {
        id
        first_name
        last_name
        phone_number
        title
        address
        initials
      }
      user {
        role {
          id
          group_id {
            group_id
            group_name
          }
        }
      }
    }
  }
`;


export const REQUEST_RESETPASSWORD_MUTATION = gql`
  mutation RequestResetPassword($email: String!) {
    requestResetPassword(email: $email) {
      userId
      username
      email
    }
  }
`;

export const RESETPASSWORD_MUTATION = gql`
  mutation ResetPassword(
    $code: String!
    $userId: String!
    $confirmPassword: String!
    $password: String!
  ) {
    resetPassword(
      code: $code
      userId: $userId
      confirmPassword: $confirmPassword
      password: $password
    ) {
      email
      userId
      username
    }
  }
`;
